module.exports = __webpack_public_path__ + "img/noData.2fc22600.png";